// extracted by mini-css-extract-plugin
export default {"label":"FormTextArea_label__bI26q"};